import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <button
      onClick={() => setLanguage(language === 'en' ? 'sr' : 'en')}
      className="flex items-center space-x-2 px-3 py-1 rounded-lg hover:bg-gray-100 transition-colors"
    >
      <span className="text-sm font-medium">
        {language === 'en' ? '🇬🇧 EN' : '🇷🇸 SR'}
      </span>
    </button>
  );
};

export default LanguageSelector;